import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.config.productionTip = false;
/**
 * @name 版本信息
 */
window.$WANRUI = {
  GITCOMMIT: process.env.VUE_APP_GITCOMMIT,
};
window.$WANRUI.VUE = new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
